import { UserRole } from '@kfolks/types'
import { z } from 'zod'

/**
 * Schema for creating a user (HTTP POST body).
 * ID and system timestamps are excluded — the service generates them.
 */
export const userCreateSchema = z.object({
	email: z.email(),
	displayName: z.string().min(1),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	avatarUrl: z.url().optional(),
	role: z.enum(UserRole).default(UserRole.USER),
	isActive: z.boolean().default(true),
})

/**
 * Schema for updating a user (HTTP PUT body).
 * All fields optional — callers send only what they want to change.
 */
export const userUpdateSchema = userCreateSchema.partial()

export type UserCreateInput = z.infer<typeof userCreateSchema>
export type UserUpdateInput = z.infer<typeof userUpdateSchema>
